<template>
  <section>
    <b-dropdown
      aria-role="list"
      class="local-lm-filters local-lm-fix--min-width"
      v-model="selectedOption"
      @active-change="sort"
    >
      <button
        class="button"
        type="button"
        slot="trigger"
      >
        <div class="local-lm-filters--placeholder">
          <template>
            <span
              v-if="!selectedOption"
              v-t="$t('OrderTableFilter.title')"
            />
            <span
              v-if="selectedOption"
              v-t="$t(`OrderTableFilter.${selectedOption}`).toUpperCase()"
            />
          </template>
          <b-icon
            icon="chevron-down"
          />
        </div>
      </button>
      <b-dropdown-item
        v-for="(orderedFilter, index) in orderedFilters"
        :key="index"
        :value="orderedFilter"
      >
        {{ $t(`OrderTableFilter.${orderedFilter}`) | upperCase }}
      </b-dropdown-item>
    </b-dropdown>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OrderTableFilter',
  computed: {
    ...mapGetters('filters', [
      'orderedFilters'
    ])
  },
  mounted () {
    this.$store.dispatch('filters/getFilters')

    this.$eventBus.$on('cleanFilters', () => {
      this.selectedOption = null
    })
  },
  data () {
    return {
      selectedOption: null
    }
  },
  methods: {
    sort () {
      if (!this.selectedOption) return

      const filters = this.$store.getters['filters/filtersSelected']

      if (!filters || (filters && filters.sort !== this.selectedOption)) {
        this.$store.dispatch('filters/setSort', this.selectedOption)
        this.$eventBus.$emit('getOrders')
      }

      const toogleFocus = !this.selectedOption || false
      this.$eventBus.$emit('selectOrderFilter', toogleFocus)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filters/OrderTableFilter.vue